import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {User} from "@core/shared/models/user";
import {Society} from "@core/shared/models/society";
import {ActivatedRoute, Router} from "@angular/router";
import {Channel, ChannelIntegrationMode, ChannelMode} from "@core/shared/models/channel";
import {LOCALE_ITEMS, LocaleItem, TranslationBuilder} from "@core/shared/models/translation";
import {Observable, of} from "rxjs";
import {Currency} from "@core/shared/models/currency";
import {FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";
import {TranslateService} from "@ngx-translate/core";
import {CurrencyService} from "@core/shared/services/currency.service";
import {ChannelService} from "@core/shared/services/channel.service";
import {FormService} from "@core/shared/services/form.service";
import {OfferSearchService} from "@core/shared/services/offer/offer-search.service";
import {REGEX_WEBSITE} from "@core/shared/models/regex";
import {Offer} from "@core/shared/models/offer";
import {ChannelTranslation} from "@core/shared/models/channel-translation";
import {Role} from "@core/shared/models/role";
import {OfferCatalogService} from "@core/shared/services/offer/offer-catalog.service";
import {OfferCatalog} from "@core/shared/models/offer/offer-catalog";
import {Access} from "@core/shared/models/access";
import {FieldCollection} from "@lib/form/field";
import {environment} from "../../../../../environments/environment";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {ClipboardService, IClipboardResponse} from "ngx-clipboard";
import {TranslationService} from "@core/shared/services/translation.service";
import {tap} from "rxjs/operators";
import {SocietyWebsite} from "@core/shared/models/society/society-website";
import {WebsiteService} from "@core/shared/services/website.service";
import {SocietyIp} from "@core/shared/models/society/society-ip";
import {UserService} from "@core/shared/services/user.service";
import {SocietyService} from "@core/shared/services/society.service";
import {CHANNEL_SORT_OPERATORS, CHANNEL_SORT_ORDER_BY, ChannelSortOperator, ChannelSortOrderBy} from "@core/shared/models/channel-sort";
import {SocietyIpService} from "@core/shared/services/society/society-ip.service";
import {FileConfig} from "@lib/form/fields/file/file.component";
import {ApiService} from "@core/shared/services/api.service";
import {SelectSearchConfig} from "@lib/form/fields/select-search/select-search.component";
import {TransportType} from '@core/shared/models/transport';

@Component({
    selector: 'app-core-page-channel-read',
    templateUrl: './page-channel-read.component.html',
    styleUrls: ['./page-channel-read.component.scss'],
    providers: [
        FormService,
        OfferSearchService
    ],
    standalone: false
})
export class PageChannelReadComponent implements OnInit {

    @ViewChild('tabGroup', {static: true}) tabGroup: MatTabGroup;

    @ViewChild('offerCardPreviewTab', {static: false}) offerCardPreviewTabRef: MatTab;

    @ViewChild('offerViewPreviewTab', {static: false}) offerViewPreviewTabRef: MatTab;

    @ViewChild('showcaseReference', { static: false }) showcaseReference: ElementRef<HTMLDivElement>;

    public user: User;

    public currentUser: User;

    public society: Society;

    public channel: Channel;

    public translationBuilder: TranslationBuilder;

    public locales$: Observable<LocaleItem[]>;

    public sortsOrderBy$: Observable<ChannelSortOrderBy[]>;

    public sortsOperators$: Observable<ChannelSortOperator[]>;

    public currencies$: Observable<Currency[]>;

    public societyWebsites$: Observable<SocietyWebsite[]>;

    public fieldCollection = new FieldCollection();

    public societyIps: SocietyIp[] = [];

    public faviconConfig: FileConfig;

    public fonts: object[] = [
        {
            id: 'font-lato',
            name: 'font Lato'
        },
        {
            id: 'font-roboto',
            name: 'font Roboto'
        },
        {
            id: 'font-source',
            name: 'font Source Sans Pro'
        },
        {
            id: 'font-nunito',
            name: 'font Nunito'
        },
        {
            id: 'font-ubuntu',
            name: 'font Ubuntu'
        },
        {
            id: 'font-raleway',
            name: 'font Raleway'
        },
        {
            id: 'font-caveat',
            name: 'font Caveat'
        },
        {
            id: 'font-amatic',
            name: 'font Amatic SC'
        },
        {
            id: 'font-poiretone',
            name: 'font Poiret One'
        },
        {
            id: 'font-opensans',
            name: 'font Open Sans'
        },
        {
            id: 'font-montserrat',
            name: 'font Montserrat'
        },
        {
            id: 'font-oswald',
            name: 'font Oswald'
        },
        {
            id: 'font-slabo',
            name: 'font Slabo'
        },
        {
            id: 'font-ptsans',
            name: 'font PT Sans'
        },
        {
            id: 'font-merriweather',
            name: 'font Merriweather'
        },
        {
            id: 'font-notosans',
            name: 'font Noto Sans'
        },
        {
            id: 'font-concertone',
            name: 'font Concert One'
        },
        {
            id: 'font-prompt',
            name: 'font Prompt'
        },
        {
            id: 'font-worksans',
            name: 'font Work Sans'
        },
        {
            id: 'font-ooohbaby',
            name: 'font Oooh Baby'
        },
        {
            id: 'font-badscript',
            name: 'font Bad Script'
        },
        {
            id: 'font-dancingscript',
            name: 'font Dancing Script'
        }
    ];

    public saveAndContinueConfiguration: { active: boolean, fragment: ('JSIntegration') } = {
        active: false,
        fragment: null
    };

    public colorBackground: string;
    public colorTitle: string;
    public colorSubTitle: string;
    public colorBackgroundButton: string;
    public colorTextButton: string;
    public colorHighlighting: string;
    public colorDescription: string;

    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _formBuilder: UntypedFormBuilder,
        private _snackBar: MatSnackBar,
        private _translateService: TranslateService,
        private _clipboardService: ClipboardService,
        private _currencyService: CurrencyService,
        private _channelService: ChannelService,
        private _offerCatalogService: OfferCatalogService,
        private _apiService: ApiService,
        private _websiteService: WebsiteService,
        private _societyService: SocietyService,
        private _societyIpService: SocietyIpService,
        public formService: FormService,
        public offerSearchService: OfferSearchService,
        public translationService: TranslationService,
        public userService: UserService
    ) {
    }

    ngOnInit(): void {

        this.currentUser = this.userService.currentUser.getValue();

        this._activatedRoute.data.subscribe((data: {channel: Channel, user: User, society: Society}): void => {

            this.channel = data.channel;

            this.user = data.user;

            this.society = data.society;

            this._configureSearchService();

            this._initForm();

            this._societyService.getItemAPI(this.channel.society.id).subscribe((society: Society): void => {

                this.society = society;

                this._initLocales();

                this._initSorts();

                this._initCurrencies();

                this._hydrateForm();

                this._loadSocietyWebsites();

                if (this.society.channelConfiguration.hasAccessAPI) {

                    this._loadSocietyIps();
                }

                if (this.isClassicMode) {

                    this._loadSelfOfferCatalogs();

                    this._configureSearchService();

                    const allConfigurationFieldsChecked: boolean = [!this.channel.allowBooking, !this.channel.allowRequest, !this.channel.allowOnlineSale, this.channel.allowGiftVoucher].every((value: boolean): boolean => {

                        return value;
                    });

                    if (!allConfigurationFieldsChecked) {

                        this._updateGiftVoucher();
                    }
                }

                this._initFaviconConfigs();

                this.colorBackground = data.channel?.style?.colorBackground;

                this.colorTitle = data.channel?.style?.colorTitle;

                this.colorSubTitle = data.channel?.style?.colorSubTitle;

                this.colorBackgroundButton = data.channel?.style?.colorBackgroundButton;

                this.colorTextButton = data.channel?.style?.colorTextButton;

                this.colorHighlighting = data.channel?.style?.colorHighlighting;

                this.colorDescription = data.channel?.style?.colorDescription;
            });

            if(!this.hasOneOfThisRoles(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']) ){

                this._loadSelfOfferCatalogs();
            }

            this.offerSearchService.selectedOffers.next(data.channel.offerCatalogs.map((item: OfferCatalog): Offer => {

                return item.offer;
            }));

            this.offerSearchService.displayReferencedOffer = this.form.get('referenced').value;

            this.offerSearchService.displayOnlyGiftVoucherOffer = false;

            this.offerSearchService.displayOnlyOnlineSaleOffer = false;

            this.form.disable();

            // Redirection automatique sur un onglet

            this._activatedRoute.fragment.subscribe((fragment: ('JSIntegration')): void => {

                switch (fragment) {

                    case "JSIntegration":

                        this.tabGroup.selectedIndex = 2;

                        break;
                }
            });

            this._handleClipboardResponse();
        });
    }

    private _loadSelfOfferCatalogs(): void {

        if(this.userService.hasOneOfThisRoles(this.currentUser, ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'])){

            this.form.get('offerCatalogs').patchValue(this.channel.offerCatalogs);
        }
        else{

            this._offerCatalogService.getItemsAPI().subscribe((items: OfferCatalog[]): void => {

                this._offerCatalogService.selfItems.next(items);

                this.offerSearchService.selectedOffers.subscribe((items: Offer[]): void => {

                    this.form.get('offerCatalogs').patchValue(items.map((item: Offer): { id: number } => {

                        const offerCatalogs: OfferCatalog[] = this._offerCatalogService.selfItems.value as OfferCatalog[];

                        const offerCatalog: OfferCatalog = offerCatalogs.find((i: OfferCatalog): boolean => {

                            return i.offer.id === item.id;
                        });

                        return {
                            id: offerCatalog.id
                        };
                    }));
                });
            });
        }
    }

    private _configureSearchService(): void {

        this.offerSearchService.selectOfferAllowed = true;
    }

    private _initForm(): void {

        this.formService.form = this._formBuilder.group({
            owner: [null, Validators.required],
            marketplace: ['', [Validators.required, Validators.pattern(REGEX_WEBSITE)]],
            locale: [null, [Validators.required]],
            currency: [null, [Validators.required]],
            searchEngine: [false, [Validators.required]],
            referenced: [false, [Validators.required]],
            enable: [false, [Validators.required]],
            integrationMode: ['subDomain'],
            allowMap: [],
            displayCo: [],
            canonicalUrl: ['', [(control: UntypedFormControl) => {

                if(!this.form)
                    return null;

                if(!this.channel.enableJS) {

                    return null;

                }

                if(control.value.length < 1) {

                    return {
                        'isRequired': {
                            valid: false
                        }
                    }
                }

                if(/^\//g.test(control.value))
                    return null;

                return {
                    'isPatternInvalid': {
                        valid: false
                    }
                }
            }]],
            offerCatalogs: [[]],
            isDistributor: [!this.hasOneOfThisRoles(['ROLE_PROVIDER', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION']), Validators.required],
            comment: [null],
            translations: new UntypedFormArray([]),
            style: this._formBuilder.group({
                id: [''],
                font: ['', Validators.required],
                colorBackground: [null],
                colorTitle: [null],
                colorDescription: [null],
                colorSubTitle: [null],
                colorBackgroundButton: [null],
                colorTextButton: [null],
                colorHighlighting: [null]
            }),
            sort: this._formBuilder.group({
                id: [''],
                orderBy: [null, Validators.required],
                operator: [null, Validators.required]
            }),
            allowedIps: [[], [Validators.required]],
            allowBooking: [false],
            allowGiftVoucher: [false],
            allowRequest: [false],
            allowOnlineSale: [false],
            allowShowcase: [false],
            displayStartFromPrice: [true, [Validators.required]],
            allowedTransports: [['train-station', 'airport'] as TransportType[]],
            hasExternalLink: [false],
            externalLinkLabel: [null],
            externalLinkUrl: [null],
        });

        this.fieldCollection.addField({
            type: 'select-search',
            config: {
                id: 'font',
                attrs: {
                    label: this._translateService.instant('channel.fields.font.value'),
                    required: true,
                    choices: this.fonts,
                    multiple: false,
                }
            }
        });

        this._initTranslationsForm();

        this.formService.submitCallback = (): void => {

            const data: object = Object.assign(this.form.value, {
                currency: {id: parseInt(this.form.get('currency').value)}
            });

            /** @ts-ignore **/
            data.translations[0].locale = data.locale;

            this._channelService.updateItemAPI(this._activatedRoute.snapshot.params['id'], data).subscribe((): void => {

                this._snackBar.open(this._translateService.instant('channel.update.success.value'), this._translateService.instant('notification.close.action.value'), {
                    duration: 5000
                });

                if (!this.saveAndContinueConfiguration.active) {
                    this.redirectToList();
                }
            });
        };
    }

    private _initTranslationsForm(): void {

        this.translationBuilder = new TranslationBuilder(this._formBuilder);

        this.translationBuilder.form = this.form;

        this.translationBuilder.addItemCallback = (): UntypedFormGroup => {

            return this._formBuilder.group({
                name: ['', [Validators.required]],
                title: ['', [Validators.required]],
                description: [null]
            });
        };
    }

    private _initLocales(): void {

        this.locales$ = of(LOCALE_ITEMS);
    }

    private _initCurrencies(): void {

        this.currencies$ = this._currencyService.getItemsAPI();
    }

    private _loadSocietyWebsites(): void {

        this.societyWebsites$ = this._websiteService.getSocietyItemsAPI(this.society.id).pipe(
            tap((societyWebsites: SocietyWebsite[]): void => {

                const societyWebsite: SocietyWebsite = societyWebsites.find((item: SocietyWebsite): boolean => {

                    return item.website === this.society.mainWebsite;
                });

                this.form.get('marketplace').patchValue(this.hasAccessAdditionalWebsite ? this.channel.marketplace : societyWebsite);
            })
        );
    }

    private _handleClipboardResponse(): void {

        this._clipboardService.copyResponse$.subscribe((response: IClipboardResponse) => {

            if (response.isSuccess) {

                this._snackBar.open(this._translateService.instant('content.copied.value'), this._translateService.instant('notification.close.action.value'), {
                    duration: 5000
                });
            }
        });
    }

    private _initSorts(): void {

        this.sortsOrderBy$ = of(CHANNEL_SORT_ORDER_BY);

        this.sortsOperators$ = of(CHANNEL_SORT_OPERATORS);
    }

    private _hydrateForm(): void {

        this.form.patchValue(Object.assign({...this.channel}, {
            owner: this.society.id,
            currency: this.channel.currency.id,
            integrationMode: this.integrationMode,
            picture: this.channel.picture || {
                copyright: '',
                image: {
                    image:''
                }
            },
            logo: this.channel.logo || {
                copyright: '',
                image: {
                    image:''
                }
            }
        }));

        this.channel.translations.forEach((translation: ChannelTranslation): void => {

            this.translationBuilder.addItemControl(this.translationBuilder.getLocaleItem(translation.locale), translation);
        });

        if(this.userService.hasOneOfThisRoles(this.currentUser,['ROLE_ADMIN','ROLE_SUPER_ADMIN'])){
            this.form.disable();
            return;
        }

        this._handleFormMarketingOptionStates();

        if(this.channel.allowShowcase){

            this.form.get('allowOnlineSale').disable({emitEvent: false, onlySelf: true});

            this.form.get('allowBooking').disable({emitEvent: false, onlySelf: true});

            this.form.get('allowRequest').disable({emitEvent: false, onlySelf: true});

            this.form.get('allowGiftVoucher').disable({emitEvent: false, onlySelf: true});

            this.offerSearchService.updateExtraData('allowShowcase', true);
        }

        this.form.get('canonicalUrl').disable();

        this.form.get('owner').disable();

        this.form.get('integrationMode').disable();

        this.form.get('referenced').disable();

        this.form.get('locale').disable();

        this.form.get('isDistributor').disable();

        this.isDistributor ? this.form.get('currency').enable() : this.form.get('currency').disable();

        this.form.get('enable').disable();

        this.hasAccessAdditionalWebsite ? this.form.get('marketplace').enable() : this.form.get('marketplace').disable();

        this.translationBuilder.itemsControl.controls.forEach((formGroup: FormGroup): void => {

            formGroup.get('name').disable();

            formGroup.get('title').disable();

        });

        this.offerSearchService.updateExtraData('isDistributor', this.form.get('isDistributor').value);
    }

    private _loadSocietyIps(): void {

        this._societyIpService.getItemsAPI(this.society.id).subscribe((items: SocietyIp[]): void => {

            this.societyIps = items;
        });
    }

    private _updateGiftVoucher(): void {

        this.offerSearchService.updateFilter$.next({
            key: 'giftVoucher.enable',
            value: this.form.get('allowGiftVoucher').value && !this.form.get('allowBooking').value && !this.form.get('allowRequest').value && !this.form.get('allowOnlineSale').value
        });
    }

    private _initFaviconConfigs(): void {

        this._translateService.get('file.extension.list.allowed.value', {list: '.ico'}).subscribe((help: string): void => {

            this.faviconConfig = {
                id: 'favicon',
                gallery: {
                    id: null,
                    type: 'file',
                    context: 'channel_favicon'
                },
                required: false,
                uploadApiUrl: this._apiService.getApiUrl(false, true),
                help: help,
                upload: {
                    maxSize : 100000,
                    allowedTypes: ['image/x-icon'].join(',')
                }
            };
        });
    }

    private _handleFormMarketingOptionStates(): void {

        this.isAllowOnlineSaleEnabled ? this.form.get('allowOnlineSale').enable({emitEvent: false, onlySelf: true}) : this.form.get('allowOnlineSale').disable({emitEvent: false, onlySelf: true});

        this.isAllowGiftVoucher ? this.form.get('allowGiftVoucher').enable({emitEvent: false, onlySelf: true}) : this.form.get('allowGiftVoucher').disable({emitEvent: false, onlySelf: true});
    }

    public redirectToList(): void {

        this._router.navigate(['account/channel/list']);
    }

    public hasRole(role: Role): boolean {

        return this.user.roles.includes(role);
    }

    public hasOneOfThisRoles(roles: Role[]): boolean {

        return roles.some((role: Role): boolean => {

            return this.hasRole(role);
        });
    }

    public hasAllOfThisRoles(roles: Role[]): boolean {

        return roles.every((role: Role): boolean => {

            return this.hasRole(role);
        });
    }

    public submitEnter($event){

        if($event.key == 'Enter'){

            $event.preventDefault();

            return;
        }
    }

    public changeFont(event): void {

        this.form.controls['style'].get('font').patchValue(event.value);
    }

    public updateColorField(value,field){

        this.form.controls['style'].get(field).patchValue(value);
    }

    public changeLocale(): void {

        this.translationBuilder.changeLocale([this.form.get('locale').value]);
    }

    public copyJSIntegrationWCContent(): void {

        this._clipboardService.copy(`<tywin-channel token="${this.channel.tokenJs}" base-url="${this.canonicalUrl}"></tywin-channel>`);
    }

    public copyJSIntegrationSourceContent(): void {

        this._clipboardService.copy(this.JSIntegrationSourceTag);
    }

    public compareSocietyWebsite(a: SocietyWebsite, b: SocietyWebsite): boolean {

        if(!a || !b){

            return false;
        }

        return a.id === b.id;
    }

    public downloadTechnicalDocumentation(): void {

        this._channelService.downloadTechnicalDocumentation(this.localeId).subscribe(blob => {

            const a: HTMLAnchorElement = document.createElement('a');

            const objectUrl: string = URL.createObjectURL(blob);

            a.href = objectUrl;

            a.download = `${this._translateService.instant('channel.technical.documentation.files.title.value')}.pdf`;

            a.click();

            URL.revokeObjectURL(objectUrl);
        });
    }

    public isAdmin(): boolean {

        return this.userService.hasOneOfThisRoles(this.currentUser, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']);
    }

    public isOneOfTheseIntegrationModes(items: ChannelIntegrationMode[]): boolean {

        const integrationMode: ChannelIntegrationMode = this.form.get('integrationMode').value;

        return items.includes(integrationMode);
    }

    public compareSocietyIp(a: SocietyIp, b: SocietyIp): boolean {

        if(!a || !b){

            return false;
        }

        return a.id === b.id;
    }

    public orderByLabel(orderBy: ChannelSortOrderBy): string {

        return this._translateService.instant(`channel.sort.orderBy.${orderBy}`);
    }

    public operatorLabel(operator: ChannelSortOperator): string {

        return this._translateService.instant(`channel.sort.operator.${operator.toLowerCase()}`);
    }

    public isSelectedAllowedTransport(type: TransportType): boolean {

        const allowedTransports: TransportType[] = this.form.get('allowedTransports').value;

        return allowedTransports.includes(type);
    }

    get sortForm(): UntypedFormGroup {

        return this.form.get('sort') as UntypedFormGroup;
    }

    get isAllowOnlineSaleEnabled(): boolean {

        if(this.hasOneOfThisRoles(['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR'])){

            if(!this.hasAccessOnlineSale){

                return false;
            }

            if (this.hasRole('ROLE_OFFER_DISTRIBUTOR') && !(this.society.isValidMangoPayAccount)) {

                return false;
            }

            if(!this.form.get('isDistributor').value && this.form.get('allowBooking').value){

                return false;
            }
        }

        if(this.hasOneOfThisRoles(['ROLE_PROVIDER', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])){

            if(!this.form.get('isDistributor').value && this.form.get('allowBooking').value){

                return false;
            }
        }

        return true;
    }

    get hasAccessGiftVoucher(): boolean {

        if(!this.society){

            return false;
        }

        const accesses = this.society.admin.accesses.filter((access: Access): boolean => {

            return access.tag === 'ONLINE_SALE';
        });

        return (accesses.length > 0);
    }

    get isAllowGiftVoucher(): boolean {

        if(this.hasOneOfThisRoles(['ROLE_PROVIDER', 'ROLE_FEDERATION', 'ROLE_INSTITUTIONAL'])){

            return true;
        }

        if(!this.hasAccessGiftVoucher){

            return false;
        }

        if(this.isDistributor){

            return this.society.isValidMangoPayAccount;
        }

        return true;
    }

    get styleForm(): UntypedFormGroup {

        return this.form.get('style') as UntypedFormGroup;
    }

    get channelMode(): ChannelMode {

        return this._activatedRoute.snapshot.data['mode'];
    }

    get isClassicMode(): boolean {

        return this.channelMode === ChannelMode.Classic;
    }

    get isDistributor(): boolean {

        return this.form.get('isDistributor').value;
    }

    get hasAccessOnlineSale(): boolean {

        if(!this.society){

            return false;
        }

        return this.society.admin.accesses.some((access: Access): boolean => {

            return access.tag === 'ONLINE_SALE';
        });
    }

    get JSIntegrationSourceTag(): string {

        return `<script src="${environment.channelBaseUrl}/build/channel/channel.js" defer></script>`;
    }

    get subDomainIntegrationLink(): string {

        return `https://${this.channel.subDomain}${environment.channelSubDomainSuffix}`;
    }

    get form(): UntypedFormGroup {

        return this.formService.form;
    }

    get localeId(): string {

        return this._translateService.currentLang;
    }

    get hasAccessAdditionalWebsite(): boolean {

        if(!this.society){

            return false;
        }

        return this.society.admin.accesses.some((access: Access): boolean => {

            return access.tag === 'ADDITIONAL_WEBSITE';
        });
    }

    get fontFieldConfig(): SelectSearchConfig {

        return this.fieldCollection.getFieldConfig('font') as SelectSearchConfig;
    }

    get marketplace(): string {

        const societyService: SocietyWebsite = (this.form.get('marketplace').value as SocietyWebsite);

        return societyService ? societyService.website : null;
    }

    get canonicalUrl(): string {

        const canonicalUrl: string = (this.form.get('canonicalUrl').value as string);

        return `${this.marketplace}${canonicalUrl}`;
    }

    get integrationMode(): ChannelIntegrationMode {

        if(!this.channel){

            return null;
        }

        const items: { [p in ChannelIntegrationMode]: boolean } = {
            subDomain: this.channel.enableSubDomain,
            JS: this.channel.enableJS,
            API: this.channel.enableApi,
            orchestra: this.channel.enableOrchestra
        };

        return Object.keys(items).find((key: ChannelIntegrationMode): boolean => {

            return Boolean(items[key]);

        }) as ChannelIntegrationMode;
    }

    get allowedIps(): string[] {

        return (this.form.get('allowedIps').value as SocietyIp[]).map((item: SocietyIp): string => {

            return item.address;
        });
    }
}
